import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetFeesAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetFeess';

  /**
   * kiểm tra phát sinh phí, lệ phí
   * @returns 
   */
   async checkAriseBudgetFees(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/checkAriseBudgetFees',
      data: param
    };

    return await httpClient.getAsync(request);
  }

  /**
   * đồng bộ danh mục phí,lệ phí thay đổi danh mục tại các chứng từ liên quan
   * @returns 
   */
   async syncBudgetFeesBumas(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/syncBudgetFeesBumas',
      data: {
        ...param
      }
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm toàn bộ phí, lệ phí từ bumas và xóa toàn bộ danh mục cũ
   * @returns 
   */
   async insertAllBudgetFeesBumasDeleteMimosa(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/insertAllBudgetFeesBumasDeleteMimosa',
      data: param
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm toàn bộ phí lệ phí từ bumas và xóa toàn bộ danh mục cũ
   * @returns 
   */
   async addBudgetFeesBumas(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/addBudgetFeesBumas',
      data: param
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thêm toàn bộ phí lệ phí từ bumas khi có phát sinh
   * @returns 
   */
   async addBudgetFeesBumasWhenArise(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/addBudgetFeesBumasWhenArise',
      data: param
    };

    return await httpClient.postAsync(request);
  }
}

export default new BudgetFeesAPI();
